/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/Vin.yaml

import { ScanbotVinImpl } from './impl';
import type { ResultWrapper } from './types/base/customTypes';
import type { VinScannerScreenConfiguration } from './types/core/ui_v2/vin/VinScannerScreenConfiguration';
import type { VinScannerUiResult } from './types/core/ui_v2/vin/VinScannerUiResult';

/**
 * Entry point for all VIN scanning features.
 */
export const ScanbotVin = {
  /**
   * Opens the Ready-To-Use UI VIN scanner with the desired configuration.
   * @param {VinScannerScreenConfiguration} configuration - The VIN scanner configuration to be used for scanning.
   * @returns {Promise<ResultWrapper<VinScannerUiResult>>} - The result of the VIN scanning operation.
   */
  async startScanner(configuration: VinScannerScreenConfiguration): Promise<ResultWrapper<VinScannerUiResult>> {
    return ScanbotVinImpl.startScanner(configuration);
  },
};
